<div class="main-content">
  <div class="container-fluid">
    <div class="row" >
      <div class="maintenance-message" *ngIf="is_show">
        <mat-icon class="text-danger-glow blink">circle</mat-icon>
        <span class="sample_data" >Unable to do voucher posting due to opening trial balance mismatch in {{name}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div *ngIf="data && data.length > 0 else noDataContent">
          <!-- <button class="btn btn-primary create-button" (click)="createVoucherPosting()">Create</button> -->
            <div class="row sticky-actions">
              <div class="col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Branch</mat-label>              
                  <mat-select [(ngModel)]="selectedBranchId" (openedChange)="onBranchOpen($event)" panelClass="branch-panel">
                    <mat-option disabled>
                      <input matInput placeholder="Search branch..." [(ngModel)]="branchSearch"
                        (ngModelChange)="onBranchSearch($event)" />
                    </mat-option>
                    <cdk-virtual-scroll-viewport itemSize="48" class="branch-viewport" (scrolledIndexChange)="onBranchScroll()">
                      <mat-option *cdkVirtualFor="let branch of branch_list" [value]="branch.id">
                        {{ branch.name }}
                      </mat-option>
                    </cdk-virtual-scroll-viewport>              
                  </mat-select>
                </mat-form-field>
              </div>

            <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ledger</mat-label>  
              <mat-select [(ngModel)]="selectedLedgerId" (openedChange)="onLedgerOpen($event)" panelClass="ledger-panel">
                <mat-option disabled>
                  <input matInput placeholder="Search ledger..." [(ngModel)]="searchTerm"
                    (ngModelChange)="onLedgerSearch($event)" />
                </mat-option>
                <cdk-virtual-scroll-viewport itemSize="48" class="ledger-viewport" (scrolledIndexChange)="onLedgerScroll()">
                  <mat-option *cdkVirtualFor="let ledger of ledger_list" [value]="ledger.id">
                    {{ ledger.ledger_name }}
                  </mat-option>
                </cdk-virtual-scroll-viewport>            
              </mat-select>
            </mat-form-field>
            </div>
              <div class="col-md-2">
                <button class="btn btn-success w-50" (click)="onSearch()">
                  Search
                </button>
              </div>
            </div>
            <div class="sticky-actions">
              <app-global-search [value]="searchTerm" (search)="applySearch($event)"></app-global-search>
            </div>
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <p class="card-category">List of Posted Voucher</p>
              <button *ngIf="isModal" mat-icon-button (click)="closeModal()" class="close-button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn btn-secondary reset-button" (click)="resetFilters()">Reset</button>
            </div>
            <div class="card-body table-responsive scroll-box" (scroll)="onScroll($event)">
              <table class="table table-hover">
                <thead class="text-warning">
                  <th>SL NO</th>
                  <!-- <th>Date</th> -->
                  <th (click)="sortData('date')" class="sortable">
                    Date
                    <mat-icon 
                      [ngClass]="{ 'asc': sortColumn === 'date' && sortDirection === 'asc', 'desc': sortColumn === 'date' && sortDirection === 'desc' }">
                      {{ sortColumn === 'date' ? (sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                    </mat-icon>
                  </th>
                  <th>Voucher Type</th>
                <th (click)="sortData('voucher_no')" class="sortable">
                  Voucher Number
                  <mat-icon
                    [ngClass]="{ 'asc': sortColumn === 'voucher_no' && sortDirection === 'asc', 'desc': sortColumn === 'voucher_no' && sortDirection === 'desc' }">
                    {{ sortColumn === 'voucher_no' ? (sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                  </mat-icon>
                </th>
                  <th>Branch Name</th>
                  <th *ngIf="is_ShowHeader">GSRN Number</th>
                  <th *ngIf="is_ShowHeader">GSSN Number</th>
                  <th *ngIf="is_ShowHeader">Vendor Name</th>
                  <th *ngIf="is_ShowHeader">Customer Name</th>
                  <th *ngIf="is_ShowHeader">External Document No</th>
                  <!-- <th>Narration</th> -->
                  <th (click)="sortData('total_cr')" class="sortable">
                    Amount
                    <mat-icon 
                      [ngClass]="{ 'asc': sortColumn === 'total_cr' && sortDirection === 'asc', 'desc': sortColumn === 'total_cr' && sortDirection === 'desc' }">
                      {{ sortColumn === 'total_cr' ? (sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                    </mat-icon>
                  </th>
                  <th>Audit Status</th>
                  <th>File</th>
                  <th></th>
                  <th>Action</th>
                  <th></th>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of data; let i = index">
                    <tr [id]="'voucher-' + item.creation_voucher_id"
                      [class.highlight-row]="item.creation_voucher_id == tracedVoucherId || item.id == tracedVoucherId || (highlightService && highlightService.is(item.creation_voucher_id))"
                      [class.pinned-row]="isModal && (item.creation_voucher_id == tracedVoucherId || item.id == tracedVoucherId)">
                      <td>{{ i + 1 }}</td>
                    <td [matTooltip]="item.date | date:'dd-MM-yyyy'" matTooltipShowDelay="750">
                     <span [innerHTML]="(item.date | date:'dd-MM-yyyy') | highlight: searchTerm"></span>
                    </td>
                    
                    <td [matTooltip]="item.voucher?.name" matTooltipShowDelay="750">
                       <span [innerHTML]="item.voucher?.name | highlight: searchTerm"></span>
                    </td>

                    <td [matTooltip]="item.voucher_no" matTooltipShowDelay="750">
                      <span [innerHTML]="item.voucher_no | highlight: searchTerm"></span>
                    </td>

                    <td [matTooltip]="item.voucher?.voucher_type === 'Inter Branch' ? getCreditBranchNames(item.voucher_credit) : item?.creation_voucher?.branch?.name" matTooltipShowDelay="750">
                      <span [innerHTML]="item.voucher?.voucher_type === 'Inter Branch' ? getCreditBranchNames(item.voucher_credit) : item?.creation_voucher?.branch?.name | highlight: searchTerm"></span>
                    </td>

                    <td *ngIf="is_ShowHeader"><span [innerHTML]="getVoucherDetail(item.creation_voucher?.creation_voucher_details, 'GRN', 'NO') | highlight: searchTerm"></span></td>
                    <td *ngIf="is_ShowHeader"><span [innerHTML]="getVoucherDetail(item.creation_voucher?.creation_voucher_details, 'GSN', 'NO') | highlight: searchTerm"></span></td>
                    <td *ngIf="is_ShowHeader"><span [innerHTML]="getVoucherDetail(item.creation_voucher?.creation_voucher_details, 'GRN', 'NAME') | highlight: searchTerm"></span></td>
                    <td *ngIf="is_ShowHeader"><span [innerHTML]="getVoucherDetail(item.creation_voucher?.creation_voucher_details, 'GSN', 'NAME') | highlight: searchTerm"></span></td>
                    <td *ngIf="is_ShowHeader"><span [innerHTML]="item.document_no | highlight: searchTerm"></span></td> 
                    

                      <!-- <td>{{ item.narration }}</td> -->
                      <td>
                        <span [innerHTML]="item.total_cr | highlight: searchTerm"></span>
                      </td>
                      <td>
                        <span [innerHTML]="item.is_audit === 1 ? 'Ok' : item.is_audit === 2 ? 'Not Ok' : 'NA' | highlight: searchTerm"></span>
                      </td>
                      <td (click)="openFileShowModal(item.creation_voucher_id,item.voucher_id)"><span class="click-here">click here</span></td>
                      <td (click)="toggleExpand(item)">
                        <ng-container *ngIf="!item.expanded">
                          <button mat-icon-button (click)="toggleTable(item)">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                          </button>
                        </ng-container>
                        <ng-container *ngIf="item.expanded">
                          <button mat-icon-button (click)="toggleTable(item)">
                            <mat-icon>keyboard_arrow_up</mat-icon>
                          </button>
                        </ng-container>
                      
                      </td>
                      <td>
                        <!-- <button *ngIf="item.is_posted !== 1" mat-icon-button color="primary" (click)="updateItem(item.creation_voucher_id)">
                          <img src="assets/img/edit.gif" alt="Edit" width="34" height="34">
                        </button> -->
                        <!-- <button mat-icon-button color="warn" (click)="deleteItem(item.id,i)">
                          <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
                        </button> -->
                        <button mat-icon-button color="#000" (click)="viewItem(item.creation_voucher_id,item.id,item?.is_audit,item?.audit?.remark,i)">
                          <img src="assets/img/view.gif" alt="View" width="34" height="34">
                        </button>
                        <button mat-icon-button color="#000" (click)="downloadpdf(item.creation_voucher_id)">
                          <mat-icon>receipt</mat-icon>
                        </button>
                      </td>
                      <!-- <td *ngIf="is_auditor">
                         <button mat-button class="btn btn-success" (click)="audit(item.id)">Audit</button>
                      </td> -->
                      <td *ngIf="is_auditor">
                        <button mat-button class="btn" [ngClass]="{
                            'btn-primary create-button': item.is_audit == 0,
                            'btn-success': item.is_audit == 1,
                            'btn-danger': item.is_audit == 2
                          }" (click)="audit(item.id,i)">
                          Audit
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="item.expanded">
                      <td colspan="8">
                        <div class="teble-secondary">
                          <table class="nested-table">
                            <thead>
                              <tr>
                                <th colspan="5" class="nested-th">Debit</th>
                              </tr>
                              <tr>
                                <th *ngIf="item.voucher.voucher_type == 'Inter Branch'">Sl No</th>
                                <th *ngIf="item.voucher.voucher_type == 'Inter Branch'">Branch</th>
                                <th>Ledger Name</th>
                                <th>Amount</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let debitItem of item.voucher_debit">
                                <td *ngIf="item.voucher.voucher_type == 'Inter Branch'">{{ debitItem.sl_no }}</td>
                                <td *ngIf="item.voucher.voucher_type == 'Inter Branch'">{{ debitItem?.branch_name}}</td>
                                <td>{{ debitItem.ledger_name}}</td>
                                <td>{{ debitItem.amount | number:'1.2-2'}}</td>
                                <td>{{ debitItem.description }}</td>
                              </tr>
                            </tbody>
                          </table>

                          <table class="nested-table">
                            <thead>
                              <tr>
                                <th colspan="5" class="nested-th">Credit</th>
                              </tr>
                              <tr>
                                <th *ngIf="item.voucher.voucher_type == 'Inter Branch'">Sl No</th>
                                <th *ngIf="item.voucher.voucher_type == 'Inter Branch'">Branch</th>
                                <th>Ledger Name</th>
                                <th>Amount</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let creditItem of item.voucher_credit">
                                <td *ngIf="item.voucher.voucher_type == 'Inter Branch'">{{ creditItem.sl_no}}</td>
                                <td *ngIf="item.voucher.voucher_type == 'Inter Branch'">{{ creditItem?.branch_name}}</td>
                                <td>{{ creditItem.ledger_name }}</td>
                                <td>{{ creditItem.amount | number:'1.2-2'}}</td>
                                <td>{{ creditItem.description }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <br />
                        <div class="total-debit">
                          <label for="total debit" class="total-debit"><strong>Total Debit : {{ item.total_dr | number:'1.2-2'
                              }}</strong>
                          </label>
                          <label for="total credit" class="total-credit"><strong>Total Credit : {{ item.total_cr | number:'1.2-2'
                              }}</strong>
                          </label>
                        </div>
                        <div class=""></div>
                        <div class="narration_box">
                          <label for="narration" class="narration"><strong>Narration</strong>
                          </label>
                          <div class="box">
                            {{ item.narration }}
                          </div>
                           <label for="narration" class="narration"><strong>Auditor Remark</strong>
                          </label>
                          <div class="box">
                            {{ item?.audit?.remark }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="loading">
                    <td colspan="9">
                      <div *ngFor="let item of [1, 2, 3, 4,5,6]" class="skeleton-row"></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="fetch-all">
            <button class="btn btn-primary" (click)="fetchAllData()">Fetch All</button>
          </div>
        </div>
        <ng-template #noDataContent>
          <div class="text-center">
            <p>No voucher posting available!</p>
            <!-- <button class="btn btn-primary alertcreate-btn" (click)="createVoucherPosting()">Create</button> -->
          </div>
        </ng-template>
      </div>
    </div>
  </div>